import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron, Badge,Glyphicon, FormControl,Label,Well,Grid,Row,Col,Thumbnail,Form,FormGroup,ControlLabel} from "react-bootstrap";
import { API } from "aws-amplify";
import ReactMarkdown from 'react-markdown/with-html'

import { Auth } from "aws-amplify";

import { CSVLink, CSVDownload } from "react-csv";
import {Ytitle} from "../components/Ytitle"
import "./Altiom.css";
import HeatMap from "react-heatmap-grid"
import Moment from 'react-moment';
import moment from "moment"
import LoaderButton from "../components/LoaderButton";
import { CartesianGrid,
  Legend,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  LineChart,
  Line,
  YAxis} from 'recharts';



function sortByKey(array, key, reverse) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

//const xLabels = new Array(24).fill(0).map((_, i) => `${i}`);
const xLabels=["","","","3AM","","","6AM","","","9AM","","","12AM","","","3PM","","","6PM","","","9PM","",""]
const yLabels = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat','Sun'];
const data = [[]]

function shake(v){
  if(v===1)
    return "shakeBack1"
  else
    return "shakeBack2"
}


function timeTooltip(value,name ,props){

  let t=new Date(value)
  return t.toLocaleString()
}


function dataTooltip(value,name,props){
  console.log(props)
  console.log(value)
  console.log(name)
//  console.log(props.payload.state_text)
  if(name==="Time"){
    let t=new Date(value)
    return t.toLocaleString()
  }
  return props.payload.state_text;
}


function extractDuration(data){
//  console.log("-----extractDutration----")

  try{
  var end=data.length
  var durationArray=[0,0]
  var countArray=[0,0]

  var minMax=[]
  var laststate=data[0].state
  var last=data[0].time
  minMax.push(data[0].state)
  for(var i=1; i<end;i++){
    var t=data[i]
    countArray[laststate]+=1
    durationArray[laststate]+=t.time-last
    last=data[i].time
    laststate=data[i].state
    minMax.push(data[i].state)

  }


}catch(err){


}
//  console.log("Array")
  //console.log(durationArray)
  //console.log(durationArray[0]/1000)
  //console.log(durationArray[1]/1000)
  //console.log("##### extractDutration ######")
  //console.log(minMax)
  return {
    "inactive_duration":durationArray[0],
    "active_count":countArray[0],
    "active_duration":durationArray[1],
    "inactive_count":countArray[0],
    "minval":Math.min(...minMax),
    "maxval":Math.max(...minMax)
  }
}


function graphTooltip(value,name ,props){
  console.log(name)
  if(name===""){
    let t=new Date(value)
    return t.toLocaleString()
  }
  return value+"°C";



}


const graphdata = [{"state": 1, "state_text": "active", "time": 1542818224816}, {"state": 0, "state_text": "inactive", "time": 1542818351737}, {"state": 1, "state_text": "active", "time": 1542818375850}, {"state": 0, "state_text": "inactive", "time": 1542818645359}, {"state": 1, "state_text": "active", "time": 1542819010320}, {"state": 0, "state_text": "inactive", "time": 1542819136641}, {"state": 1, "state_text": "active", "time": 1542823011455}, {"state": 0, "state_text": "inactive", "time": 1542823137619}, {"state": 1, "state_text": "active", "time": 1542823211985}, {"state": 0, "state_text": "inactive", "time": 1542823437269}, {"state": 1, "state_text": "active", "time": 1542823700813}, {"state": 0, "state_text": "inactive", "time": 1542823826552}, {"state": 1, "state_text": "active", "time": 1542823886789}, {"state": 0, "state_text": "inactive", "time": 1542824009977}, {"state": 1, "state_text": "active", "time": 1542825243869}, {"state": 0, "state_text": "inactive", "time": 1542825406503}, {"state": 1, "state_text": "active", "time": 1542828079328}, {"state": 0, "state_text": "inactive", "time": 1542828205241}, {"state": 1, "state_text": "active", "time": 1542875804800}, {"state": 0, "state_text": "inactive", "time": 1542876074320}, {"state": 1, "state_text": "active", "time": 1542876656925}, {"state": 0, "state_text": "inactive", "time": 1542876801207}, {"state": 1, "state_text": "active", "time": 1542877728367}, {"state": 0, "state_text": "inactive", "time": 1542877852727}, {"state": 1, "state_text": "active", "time": 1542879140118}, {"state": 0, "state_text": "inactive", "time": 1542879267719}, {"state": 1, "state_text": "active", "time": 1542879330195}, {"state": 0, "state_text": "inactive", "time": 1542879455547}, {"state": 1, "state_text": "active", "time": 1542879759369}, {"state": 0, "state_text": "inactive", "time": 1542879888440}, {"state": 1, "state_text": "active", "time": 1542880499476}, {"state": 0, "state_text": "inactive", "time": 1542880629457}, {"state": 1, "state_text": "active", "time": 1542881264321}, {"state": 0, "state_text": "inactive", "time": 1542881391033}, {"state": 1, "state_text": "active", "time": 1542881406366}, {"state": 0, "state_text": "inactive", "time": 1542881707522}, {"state": 1, "state_text": "active", "time": 1542881826621}, {"state": 0, "state_text": "inactive", "time": 1542881956518}, {"state": 1, "state_text": "active", "time": 1542882621295}, {"state": 0, "state_text": "inactive", "time": 1542882748413}, {"state": 1, "state_text": "active", "time": 1542882767948}, {"state": 0, "state_text": "inactive", "time": 1542882893347}, {"state": 1, "state_text": "active", "time": 1542882898314}, {"state": 0, "state_text": "inactive", "time": 1542883021915}, {"state": 1, "state_text": "active", "time": 1542883067615}, {"state": 0, "state_text": "inactive", "time": 1542883301537}, {"state": 1, "state_text": "active", "time": 1542883677134}, {"state": 0, "state_text": "inactive", "time": 1542883803626}, {"state": 1, "state_text": "active", "time": 1542884518021}, {"state": 0, "state_text": "inactive", "time": 1542884644437}, {"state": 1, "state_text": "active", "time": 1542884650190}, {"state": 0, "state_text": "inactive", "time": 1542884891272}, {"state": 1, "state_text": "active", "time": 1542885026035}, {"state": 0, "state_text": "inactive", "time": 1542885164649}, {"state": 1, "state_text": "active", "time": 1542885738846}, {"state": 0, "state_text": "inactive", "time": 1542885986537}, {"state": 1, "state_text": "active", "time": 1542886545495}, {"state": 0, "state_text": "inactive", "time": 1542886710309}, {"state": 1, "state_text": "active", "time": 1542886771714}, {"state": 0, "state_text": "inactive", "time": 1542886897894}, {"state": 1, "state_text": "active", "time": 1542887058558}, {"state": 0, "state_text": "inactive", "time": 1542887181347}, {"state": 1, "state_text": "active", "time": 1542887199566}, {"state": 0, "state_text": "inactive", "time": 1542887640219}, {"state": 1, "state_text": "active", "time": 1542887908301}, {"state": 0, "state_text": "inactive", "time": 1542888038037}, {"state": 1, "state_text": "active", "time": 1542888040482}, {"state": 0, "state_text": "inactive", "time": 1542888170649}, {"state": 1, "state_text": "active", "time": 1542888415585}, {"state": 0, "state_text": "inactive", "time": 1542888546065}, {"state": 1, "state_text": "active", "time": 1542888614474}, {"state": 0, "state_text": "inactive", "time": 1542888972853}, {"state": 1, "state_text": "active", "time": 1542889688008}, {"state": 0, "state_text": "inactive", "time": 1542889813898}, {"state": 1, "state_text": "active", "time": 1542890037789}, {"state": 0, "state_text": "inactive", "time": 1542890199635}, {"state": 1, "state_text": "active", "time": 1542890664801}, {"state": 0, "state_text": "inactive", "time": 1542890791797}, {"state": 1, "state_text": "active", "time": 1542891045382}, {"state": 0, "state_text": "inactive", "time": 1542891171524}, {"state": 1, "state_text": "active", "time": 1542891333265}, {"state": 0, "state_text": "inactive", "time": 1542891459390}, {"state": 1, "state_text": "active", "time": 1542892179520}, {"state": 0, "state_text": "inactive", "time": 1542892306106}, {"state": 1, "state_text": "active", "time": 1542892457395}, {"state": 0, "state_text": "inactive", "time": 1542892581477}, {"state": 1, "state_text": "active", "time": 1542893502197}, {"state": 0, "state_text": "inactive", "time": 1542893628453}, {"state": 1, "state_text": "active", "time": 1542893845787}, {"state": 0, "state_text": "inactive", "time": 1542893969486}, {"state": 1, "state_text": "active", "time": 1542894618553}, {"state": 0, "state_text": "inactive", "time": 1542894745608}, {"state": 1, "state_text": "active", "time": 1542895046780}, {"state": 0, "state_text": "inactive", "time": 1542895174628}, {"state": 1, "state_text": "active", "time": 1542895635116}, {"state": 0, "state_text": "inactive", "time": 1542895836456}, {"state": 1, "state_text": "active", "time": 1542896807840}, {"state": 0, "state_text": "inactive", "time": 1542897010476}, {"state": 1, "state_text": "active", "time": 1542897260169}, {"state": 0, "state_text": "inactive", "time": 1542897386280}, {"state": 1, "state_text": "active", "time": 1542897572841}, {"state": 0, "state_text": "inactive", "time": 1542897937926}, {"state": 1, "state_text": "active", "time": 1542898024668}, {"state": 0, "state_text": "inactive", "time": 1542898150382}, {"state": 1, "state_text": "active", "time": 1542898212735}, {"state": 0, "state_text": "inactive", "time": 1542898338290}, {"state": 1, "state_text": "active", "time": 1542899999654}, {"state": 0, "state_text": "inactive", "time": 1542900274250}, {"state": 1, "state_text": "active", "time": 1542900341036}, {"state": 0, "state_text": "inactive", "time": 1542900527600}, {"state": 1, "state_text": "active", "time": 1542901131453}, {"state": 0, "state_text": "inactive", "time": 1542901257268}, {"state": 1, "state_text": "active", "time": 1542901761562}, {"state": 0, "state_text": "inactive", "time": 1542901887693}, {"state": 1, "state_text": "active", "time": 1542903495913}, {"state": 0, "state_text": "inactive", "time": 1542903739525}, {"state": 1, "state_text": "active", "time": 1542903776051}, {"state": 0, "state_text": "inactive", "time": 1542903898901}, {"state": 1, "state_text": "active", "time": 1542904150921}]


function CustomizedShape(){
  return ("<circle ></circle >")
}

function icon_from_name(name_string){
	var name=name_string.toLowerCase()
  var default_input_icon='fa-exclamation'
	//Default icon
	var r=default_input_icon
	//first item is the icon you want followed by a list of words to associate to that icon
	var iconlist=[
      ['fa-close','disable','No input'],
			['fa-bed','bed','bedroom','epilepsy','enuresis','bed wet','enuresis sensor'],
			['fa-volume-up','audio','mic','microphone','sound','sound detector','noise detector','shout detector'],
			['fa-paw','motion','motion detector','PIR','movement','movement sensor','motion sensor'],
			['fa-tint','flood'],
			['fa-sign-out','door'],
			['fa-windows','window','windows'],
			['fa-square','floor'],
			['fa-bell','buzzer','beep','bell','beep test', 'buzz'],
			['fa-lightbulb-o','lamp on','light on','lights on','lamp on','light off','lamp off','lights off'],
			['fa-phone','make call','call'],
			['fa-mobile','sms','text','send text','send sms'],
			['fa-envelope-o','email','mail','send email','send mail'],
			['fa-archive','log'],
			['fa-times','no action'],
      ['fa-thermometer-half','Temperature Sensor']

		]

	//convert everything to lowercase
	iconlist=JSON.parse(JSON.stringify(iconlist).toLowerCase())

	iconlist.forEach(function(e){
		if(e.indexOf(name)!==-1){
			r=e[0];
		}
	});

  if (r==default_input_icon){
    if (name.includes("fridge") || name.includes("freezer") || name.includes("temperature") )
      r='fa-thermometer-half'
  }
	return r;
}

function InputDisplay(props){
  var l=props.data
  let value_suffix=""
  let alert=""
  let icon_name=icon_from_name(l.name)

  let avg12h=""
  let logic_count=0

let momenttime=(<Moment fromNow>{new Date(l.last*1000-2000)}</Moment>)


if(l.tamper==1){
    alert=<Badge title="Case is open">!</Badge>

  }
  if ("avg12h" in l){
        avg12h=(<span><br/><i><span className="lineAbove">12h </span>({l.avg12h}°C)</i></span>)
    }

    if("type" in l){
      if(l.type==512){
          icon_name="fa-thermometer-half"
      }
    }


if(l.last==0 || l.last==""|| l.last==undefined ){
  momenttime="---"
}

if(props.data.disabled===true || props.data.hide===true){
  return ("")
}
else{
  return (<div key={l.id} onClick={()=>props.callback(props.data)} className="col textCenter" title={new Date(l.last*1000)}><div><div className={'inputCircle '+shake(l.state)}><i className={"fa "+icon_name+" fa-2x"}></i></div></div>{l.name}:<b>{l.state_text}</b><p>{momenttime}</p></div> )
}

}


function processHeatMap(data){
  //Incomming data contains a time and a date, and a count.
  let heat=[
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
  ]
  let now=new Date()
  let currentDay=now.getDay()-1
  if(currentDay==-1)
    currentDay=6
  for(let i=0;i<data.length;i++){
    //console.log(data[i])

    let time=new Date(data[i].key)
  //  console.log(time)
    let h=time.getHours()
    let d=time.getDay()-1
    if(d==-1)
      d=6


    try{
      if(currentDay==d && h >(now.getHours())){
        heat[d][h]=0
      }
      else{
        heat[d][h]=data[i].doc_count
      }

    }catch(err){

    }
  }


  return heat









}




export default class Altiom extends Component {
    constructor(props) {
      super(props);
      this.state = {
        md_auth:null,
        md_unauth:null,
        invalid:false,
        data:{},
        heatmap:[],
        eventmap_loading:true,
        eventmap:[],
        loading:true,
        historyText:"",
        startDate:"",
        historyLoading:false,
        rawLoading:true,
        raw:[],
        inputData:[],
        inputExtra:"",
        inputExtraDate:"",
        tupdate:"",
        isUpdating:false,
        isPicBootload:false,
        pictime:"",
        picButtonText:"Update PIC",
        inputGraph:[],
        graphmode:"binary",
        inputGraphYaxis:"",
        showgraph:false,
        graphdate:"",
        input_active:"---",
        input_inactive:"---",
        active_duration:0,
        active_count:0,
        inactive_duration:0,
        inactive_count:0,
        minval:0,
        maxval:0,
        email:"",
        day:0,
        timestring:"",
        img_url:"",
        img_title:"",
        cam_dis:false,
        files: [],
        history_filter:"",
        history_time:0,
        history_csv:[],
        history_datetime_show:false,
        history_time_start:"",
        history_time_end:"",
        history_info:"",
        version_num:"0.0"
      };
    }

    checkVersion=(v)=>{
      let ver_req=v.split(".")
      let ver_real=this.state.version_num.split(".")
      for(let i=1;i<ver_req.length;i++){
        //alert((parseInt(ver_real[i])))
        if(parseInt(ver_real[i])< parseInt(ver_req[i])){
          return false
        }
      }
      return true



    }


    reset(){
      this.setState({"day":0})
      this.getDayData(0)
    }

    today(){
      let time=new Date()
      time.setHours(0)
      time.setMinutes(0)
      time.setSeconds(0)
      time.setMilliseconds(0)
      return time.getTime()
   }
   forward(){
     console.log("Forward")
     let day=this.state.day
     day=day+1
     this.setState({day:day})
     this.getDayData(day)
   }
   backward(){
     console.log("Backward")
     let day=this.state.day
     day=day-1
     this.setState({day:day})
     this.getDayData(day)
   }

   dayString(day){
     let time=this.today()
     time=time+(24*3600000*day)
     console.log("Get Day Data"+day)
     let datetime=new Date(time)
     if(day==-1){
       this.setState({timestring:"Yesterday "+datetime.toLocaleDateString()})
     }
     else if(day>0){
       this.setState({timestring:"Future! "+datetime.toLocaleDateString()})
     }
     else if (day==0) {
       this.setState({timestring:"Today"})
     }
     else{
       this.setState({timestring:datetime.toLocaleDateString()})
     }
   }


  async getDayData(day){
    this.dayString(day)
    let time=this.today()
    time=time+(24*3600000*day)
    this.setState({"inputExtraDate":new Date(time).toLocaleDateString()})

    //time=time+(24*3600000*this.state.day)

    const cdata = await this.getInputGraphData(this.activeInputID,time , time+(24*3600000))

    this.updateChart(cdata,time+(24*3600000))

    //do request



  }





  async imageList(){
    let imageData=await this.getImageActivity()
    imageData=sortByKey(imageData,"lastmodified").reverse()
    console.log("Image Activity")
    this.setState({files:imageData})
    console.log(imageData)
    this.setState({cam_dis:false})
  }
  async componentWillMount() {
    console.log("GET ALTIOM")



      try {
    //    this.reset()
        const data = await this.getAltiom();
        console.log(data)
        if(data=="none")
            this.setState({"invalid":true})
          try{
            let version=0.0
            version=parseFloat(data.VERSION.split(".")[2]+"."+data.VERSION.split(".")[3])
            this.setState({version_num:data.VERSION})
      }
      catch(err){}




        this.setState({data:data });
        let heat=processHeatMap(data.input_heat)
        this.setState({heatmap:heat });
        this.setState({"loading":false})
        const cdata = await this.getChart(0xA0002,0);
        let hdata=processHeatMap(cdata)
        console.log(hdata)
        this.setState({eventmap:hdata})
        this.setState({eventmap_loading:false})




        this.inup = setInterval(()=> this.updateinput(), 5000)
        //This request can be bundled into the first request, this will in future just be called periodicly
        this.updateinput()

        let imageData=await this.getImageActivity()
        imageData=sortByKey(imageData,"lastmodified").reverse()
        console.log("Image Activity")
        this.setState({files:imageData})
        console.log(imageData)


        //console.log(this.state.data)
      } catch (e) {
        console.log(e)
        //alert(e);
      }

      //const userinfo = await Auth.currentUserInfo();
      //this.setState({email:userinfo.attributes.email})

    }

    async getDataRefresh(){
      console.log("Refresh Data")
      const data = await this.getAltiom();
      console.log(data)
      if(data=="none")
          this.setState({"invalid":true})
      this.setState({data:data });
      if (data.update_time!=this.state.tupdate){
        this.setState({"isUpdating":false})
      }

      if(this.state.isUpdating==true){
        this.reloadData=setTimeout(()=> this.getDataRefresh(), 10000)
      }


      if(data.reg_state==true){
        console.log("Registration is open")
        this.reloadData=setTimeout(()=> this.getDataRefresh(), 5000)
      }

      if(this.state.isPicBootload==true){
        if(this.state.pictime!=data.pic_time){
        this.setState({"isPicBootload":false})
        try{
          if (data.pic_state==false){

            this.setState({"picButtonText":"Bootloader Failed"})
          }
          if (data.pic_state==true){

            this.setState({"picButtonText":"Sucessfully Updated"})
          }
        }
        catch(err){
            this.reloadData=setTimeout(()=> this.getDataRefresh(), 10000)

        }

        }else{
          this.reloadData=setTimeout(()=> this.getDataRefresh(), 10000)
        }
      }


    }


    async updateinput(){

      const inputData=await this.getInputdata()
      console.log(inputData)
      this.setState({inputData:inputData})


    }

    buttonPress =(e)=>{

    let data=e.currentTarget.dataset
    console.log(data)

if(data.cmd=="customBeep"){
    data={cmd:"action",data:{cmd:"buzzer",count:1,ontime:200,offtime:100}}
}



  if(data.cmd=="customCAM"){
      data={cmd:"action",data:{
       "url": "CAM_URL",
       "cmd": "getimage"
      }}
this.setState({cam_dis:true})
      setTimeout(()=>this.imageList(), 5000)
  }




    if(data.cmd=="PIC"){
      if(data.type=="bootloader"){
        this.setState({"pictime":this.state.data.pic_time})
        this.setState({"isPicBootload":true})
        this.reloadData=setTimeout(()=> this.getDataRefresh(), 10000)
      }
    }


    if(data.cmd=="DECT"){
        this.reloadData=setTimeout(()=> this.getDataRefresh(), 3000)
      }

    if(data.cmd=="update"){

      this.setState({"tupdate":this.state.data.update_time})
      this.setState({"isUpdating":true})
      this.reloadData=setTimeout(()=> this.getDataRefresh(), 10000)
    }



    API.post("AltiomData", "/altiom/"+this.props.match.params.id,{body:data}).then(response => {
      console.log(response)
      }).catch(error => {
          console.log(error.response)
      });

    }

     gridClick =async(hour,day,event)=>{
       console.log("Grid Click")
       var days=["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
       var a=new Date()
       var currentDay=a.getDate()
       var currentWD=a.getDay()-1
       var daydiff=0
       console.log("Current Weekday "+currentWD+" Target:"+day)

       //need to calculate the distance from the current day
       //This needs to be done in hours so that the current day we are on lines up correctly. potentially hightlight the current day also.
       if(day>currentWD){
            daydiff=currentWD+(7-day);
        }else{
            daydiff=(currentWD-day);
            if(daydiff==0 && a.getHours()<hour){
              daydiff=7
              return
            }
        }
        a.setDate(a.getDate()-daydiff);
        a.setHours(hour)
        a.setMinutes(0)
        a.setSeconds(0)
        let start_time=a.getTime()
      //i may need a timezone offset?
      start_time=start_time -a.getTimezoneOffset()*3600
      let end_time=start_time+3600000
      this.setState({"historyText":"Loading data for "+a.toLocaleString()})
      this.history_get(start_time,end_time)
    /*  const cdata = await this.getAltdata(0xA0000,start_time,end_time);
      let temp=[]
      for(var i=0;i<cdata.hits.length;i++){
        console.log(cdata.hits[i]["_source"])
        temp.push(cdata.hits[i]["_source"])
      }
      this.setState({"raw":temp})
      this.generateCSV()
      this.setState({history_time:start_time})
      this.setState({"rawLoading":false})*/
    }
request_report=async()=>{
  if(this.state.history_time_start==""){
    this.setState({history_info:"Please select start data and time"})
    return
  }
  if(this.state.history_time_end==""){
    this.setState({history_info:"Please select end data and time"})
    return
  }
  let start_dt=new Date(this.state.history_time_start)
  let end_dt=new Date(this.state.history_time_end)
  end_dt.setHours(23)
  end_dt.setMinutes(59)
  end_dt.setSeconds(0)
  let start=start_dt.getTime()
  let end=end_dt.getTime()
  if(end<start){
    this.setState({history_info:"Start time must be before end time!"})
    return
  }
  if (this.state.email.length==0){
    const userinfo = await Auth.currentUserInfo();
    this.setState({email:userinfo.attributes.email})

  }
  const cdata = await this.requestSQS(0xA0000,start,end,this.state.email);
  this.setState({history_info:"Report request sent, please check email for no-reply@altiom.care"})
}


history_load=()=>{
  console.log("load history")
  console.log(this.state.history_time_start)
  console.log(this.state.history_time_end)
  if(this.state.history_time_start==""){
    this.setState({history_info:"Please select start data and time"})
    return
  }
  if(this.state.history_time_end==""){
    this.setState({history_info:"Please select end data and time"})
    return
  }
  let start_dt=new Date(this.state.history_time_start)
  let end_dt=new Date(this.state.history_time_end)
  end_dt.setHours(23)
  end_dt.setMinutes(59)
  end_dt.setSeconds(0)
  let start=start_dt.getTime()
  let end=end_dt.getTime()
  if(end<start){
    this.setState({history_info:"Start time must be before end time!"})
    return
  }
  //-a.getTimezoneOffset()*3600
  this.setState({history_info:""})
  console.log(start)
  console.log(end)
    this.setState({"historyText":"Loading data for "+start_dt.toLocaleString()+" --> " +end_dt.toLocaleString()})
  this.history_get(start,end)
}

    history_get=async(start_time,end_time)=>{

      const cdata = await this.getAltdata(0xA0000,start_time,end_time);
      let temp=[]
      for(var i=0;i<cdata.hits.length;i++){
        //console.log(cdata.hits[i]["_source"])
        temp.push(cdata.hits[i]["_source"])
      }
      this.setState({"raw":temp})
      this.generateCSV()
      this.setState({history_time:start_time})
      console.log(temp.length)
      if(temp.length>=5000){
        this.setState({"history_info":"*****First 5000 records loaded, select a smaller window "})
      }
      else{
        this.setState({"history_info":"Loaded "+temp.length+" records"})
      }
      this.setState({"rawLoading":false})
    }

history_filter(filter){
  this.setState({history_filter:filter})



}

    generateCSV(){



      let tempCSV=[["ALtiom ID","Time","Type","id","Description","Input name","Input state","value","level","raw"]]

      for (var i=0;i<this.state.raw.length;i++){
          let data_type=""
          let data_string=""
          let data_input_name=""
          let data_input_state=""
          let data_value=""
          let data_level=""
          let data_id=""
          if(this.state.raw[i].type==655361){
            data_type="Input"
            data_string=this.state.raw[i].name+":"+this.state.raw[i].state_text
            data_input_name=this.state.raw[i].name
            data_input_state=this.state.raw[i].state_text
            data_value=this.state.raw[i].state
            data_id=this.state.raw[i].inputId
          }

          if(this.state.raw[i].type==655362){
            data_type="Event"
            data_string=this.state.raw[i].Description
            data_value=this.state.raw[i].state
            data_level=this.state.raw[i].level
            data_id=this.state.raw[i].logicIndex
          }



          tempCSV.push([this.state.raw[i].altid,
                        moment(this.state.raw[i].time).format('YYYY-MM-DD HH:mm:ss'),
                        data_type,
                        data_id,
                        data_string,
                        data_input_name,
                        data_input_state,
                        data_value,
                        data_level,
                        JSON.stringify(this.state.raw[i])
                      ])
      }
      console.log(tempCSV)
      this.setState({history_csv:tempCSV})

    }

    getInputdata(){

return API.get("AltiomData", "/altiom/"+this.props.match.params.id+"/0/InputUpdate");

    }


    getImageActivity(){


    return API.get("AltiomData", "/altiom/"+this.props.match.params.id+"/1/imageActivity");

  }

  delImageActivity(key,mode){
    let mydata = {
      'queryStringParameters': {
          'key': key,
          'mode':mode
      }
    }

  return API.get("AltiomData", "/altiom/"+this.props.match.params.id+"/1/delimage",mydata);

}




    getInputGraphData(inputId,from_time,to_time){
      let mydata = {
        'queryStringParameters': {
            'from': from_time,
            'to': to_time,
            "inputId":inputId
        }
      }
      console.log("Running request")
     return API.get("AltiomData", "/altiom/"+this.props.match.params.id+"/1/inputActivity", mydata);


    }

    requestSQS(type,from_time,to_time,email){
      let mydata = {
        'queryStringParameters': {
            'from': from_time,
            'to': to_time,
            'email':email
        }
      }
      console.log("Running request")
      return API.get("AltiomData", "/altiom/"+this.props.match.params.id+"/"+type+"/sqs", mydata);


    }

     getAltdata(type,from_time,to_time){
       let mydata = {
         'queryStringParameters': {
             'from': from_time,
             'to': to_time
         }
       }
       console.log("Running request")
      return API.get("AltiomData", "/altiom/"+this.props.match.params.id+"/"+type+"/altiom", mydata);
    }


    getChart(type,mode){
      return API.get("AltiomData", "/altiom/"+this.props.match.params.id+"/"+type+"/"+mode);
    }
    getAltiom(){


      return API.get("AltiomData", "/altiom/"+this.props.match.params.id);
    }
    defined(v){
      if(v===undefined)
        return ""
        return v
    }



    logitem(data,index){
      let type="Unknown"
      let message=""
    //  console.log("LOG ITEM "+index)

    if(this.state.history_filter==data.type){
      return
    }

      switch(data.type){
        case 0xA0000:
          return ""

        case 0xA0001:
            message=(<span><b>Input:</b>{data.name}:{data.state_text}</span>)
            break;
        case 0xA0002:



            let levels=["None" ,"Green","Amber", "Red"]
            let label=(<Label className={"alert"+levels[data.level]}>{levels[data.level]}</Label>)
            if(data.state==1){
              if(data.name=="Temperature Alert"){
                  message=<span><b>Event:</b>{data.name} <b>True</b> {label}<p>{data.Description}</p></span>
              }
              else{
                message=(<span><b>Event:</b>{data.name} <b>True</b> {label}</span>)
              }
            }
            if(data.state==0){
              if(data.name=="Temperature Alert"){
                  message=<span><b>Event:</b>{data.name} <b>False</b> {label}<p>{data.Description}</p></span>
              }
              else{
              message=(<span><b>Event:</b>{data.name} <b>False</b> {label}</span>)
              }
            }

            break;
        case 0xA0003:
            type="Var Data"

            message=(<span><Label>{data.name}</Label>&nbsp;{data.value_str}</span>)


            break;
          case 0xA0004:
                type="Var Data"
                message=(<span><Label>Script Error</Label><b>&nbsp;{data.name}</b><p>{data.value_str}</p></span>)
                  break;
      }
      var time=new Date(data.time)



      return (<p key={index}title={JSON.stringify(data)} ><small>{time.toLocaleString()}</small> {message}</p>)

    }


    updateChart(cdata,totime){

      if(cdata.length>0){
        let index=cdata.length-1
        //let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:totime}

        let now=new Date().getTime()

        if(now<totime){
          let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:new Date().getTime()}
          cdata.push(temp)
        }
        else{
          let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:totime}
          cdata.push(temp)
        }
      }
      this.setState({inputGraph:cdata})
      console.log(extractDuration(cdata))
      let dur=extractDuration(cdata)
      console.log(dur)
      this.setState(dur)




    }

    dateChange=async(e)=>{
      this.setState({graphdate:e.target.value})
      // /     time=time+(24*3600000*day)
        let now=new Date()
        let difference=(new Date(e.target.value).getTime()-now.getTime());
        difference=parseInt(difference/(3600000*24))
        console.log("Days:"+difference)
        this.setState({days:difference})
        this.dayString(difference)
      console.log(e.target.value)
      this.setState({"inputExtraDate":new Date(e.target.value).toLocaleDateString()})
      console.log(e.target.value)
      this.setState({current_date:e.target.value})
      console.log(e.target.value)
      let fromtime=new Date(e.target.value)
      fromtime.setHours(0)
      fromtime.setMinutes(0)
      fromtime=fromtime.getTime()
      let totime=fromtime+(3600000*24)
      const cdata = await this.getInputGraphData(this.activeInputID,fromtime , totime)

      this.updateChart(cdata,totime)
    /*  if(cdata.length>0){
        let index=cdata.length-1
        //let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:totime}
        console.log(totime)
        let now=new Date().getTime()

        if(now<totime){

          if(now>fromtime){
          let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:new Date().getTime()}
          cdata.push(temp)
        }
        }
        else{
          let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:totime}
          cdata.push(temp)
        }


      }
      this.setState({inputGraph:cdata})*/
      console.log(cdata)
    }
toggleGraph=()=>{

    this.setState({showgraph:false})
}

    inputGraph=async(e)=>{
      this.dayString(this.state.day)
      let time=this.today()
      time=time+(24*3600000*this.state.day)
      let date=new Date(time)

      //let date=new Date()
      let dateStr = date.getFullYear() + '-'+ ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
      this.setState({graphdate:dateStr})


      this.setState({"inputExtra":"Activity for input "+e.name})
      this.setState({"inputExtraDate":new Date().toLocaleDateString()})
      this.activeInputID=e.id

      this.setState({"input_active":e.name_active})
      this.setState({"input_inactive":e.name_inactive})


      let inputid=e.id
      if("type" in e){
        console.log("Input has a type")
        if(e.type==512){
          this.setState({graphmode:"temperature"})
        }else{
        this.setState({graphmode:"binary"})
        }
      }
      else{
        this.setState({graphmode:"binary"})
      }

      this.setState({inputGraphYaxis:e.name_inactive+" <-> "+e.name_active})
      this.setState({inputGraphYaxis:e.name_active})

      //graphmode


      this.setState({showgraph:true})
      let to=new Date()
      let from=date
      from.setHours(0)
      from.setMinutes(0)
      from.setSeconds(0)

      to=from.getTime()+(3600000*24)
      const cdata = await this.getInputGraphData(inputid,from.getTime(), to)
      this.updateChart(cdata,to)
    /*  if (cdata.length==1){
        //We only have 1 data point we need to make that match up to now?
        let temp={state:cdata[0].state, state_text:cdata[0]["state_text"], time:new Date().getTime()}
        temp.time=new Date().getTime()
        console.log(temp)
        cdata.push(temp)


      }*/

      let totime=to
    /*  if(cdata.length>0){
        let index=cdata.length-1
        //let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:totime}
        console.log(totime)
        let now=new Date().getTime()

        if(now<totime){
          let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:new Date().getTime()}
          cdata.push(temp)
        }
        else{
          let temp={state:cdata[index].state, state_text:cdata[index]["state_text"], time:totime}
          cdata.push(temp)
        }
      }

      this.setState({inputGraph:cdata})
      console.log(cdata)
      console.log(extractDuration(cdata))
      let dur=extractDuration(cdata)
      console.log(dur)
      this.setState(dur)
      */
    }


timeHMS(timeInSeconds) {
timeInSeconds=  timeInSeconds/1000
      var pad = function(num, size) { return ('000' + num).slice(size * -1); },
      time = parseFloat(timeInSeconds).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60),
      milliseconds = time.slice(-3);

      return pad(hours, 2) + 'h ' + pad(minutes, 2) + 'm ' + pad(seconds, 2) +'s'




}
futureCheck=(d)=>{
  if(d>=0){
    return true
  }
  return false
}

loadimage=(d)=>{
  console.log(d)
  this.setState({"img_title":d.name,"img_url":d.full})
}

 delimage=async(d,i)=>{

      let tempfiles=this.state.files
      console.log(d.full)
      tempfiles.splice(i, 1);
      this.setState({"files":tempfiles})
      this.setState({"img_title":"","img_url":""})
      console.log("Delete "+i)
      let imageData=await this.delImageActivity(d.name,"single")
    //this.setState({"img_title":d.name,"img_url":d.full})

}


    inputSort(a,b){
      if(a.name<b.name){
        return -1
      }
      else{
        return 1
      }
        return 0
      }
      render() {






        if(this.state.invalid==true){
          return (          <div className="Home">
                  <Jumbotron>
                      <h2 title={this.props.match.params.id}>Not a valid id </h2>




                    </Jumbotron>
                  </div>)

      }
  if(this.state.loading==true){
      return(<Jumbotron>
        <h2 title={this.props.match.params.id}>Loading...</h2>
      </Jumbotron>)
  }


    if(this.state.data.controlight==true){
      return(  <Jumbotron>  <Button className="pull-right" onClick={()=>this.props.history.goBack()}>Back</Button><h2 title={this.props.match.params.id}>Controlight Gui interface </h2>

        <p><b><a href={"http://controlight.s3-website-eu-west-1.amazonaws.com/?id="+this.props.match.params.id}>Link to Gui</a></b></p>
        <p><b>ID:</b>{this.props.match.params.id}</p>
        <p><b>Version:</b>{this.state.data.VERSION}</p>
        </Jumbotron>)
    }


      let altiomObj=this
      return (
          <div className="Home">
          <Jumbotron>
            <Button className="pull-right" onClick={()=>this.props.history.goBack()}>Back</Button>
              <h2 title={"V"+this.defined(this.state.data.VERSION)+" "+this.defined(this.state.data.IP)}>

              <b>UNIT:</b>{this.defined(this.state.data.UNIT)}<br/>

              <b>ROOM:</b>{this.defined(this.state.data.ROOM)}
              <small className="pull-right">({this.props.match.params.id})</small></h2>
              <span >{this.state.data.online ? <Badge title={new Date(this.state.data.last_seen)}>Online</Badge>:<Badge title={new Date(this.state.data.last_seen)}>Offline</Badge>}</span>
              {this.state.data.reboot_state ? <Badge title={new Date(this.state.data.reboot_time)}>Rebooting</Badge>:<span></span>}

              <hr/>
              <p>Current State</p>


              <div className="flex-grid">{this.state.inputData.sort((a,b)=>this.inputSort(a,b)).map((l) =><InputDisplay key={l.id} data={l} callback={this.inputGraph}></InputDisplay>)}</div>







              <Well>

              {this.state.showgraph? (


              <center>
              <Button className="pull-right" onClick={()=>this.toggleGraph()}><i className="fa fa-close"> </i></Button>
<h3>Recent Activity <span>({this.state.timestring})</span></h3>
<br/>
{this.state.inputExtra} ({this.state.inputExtraDate})

              {this.state.graphmode=="temperature"? (
<div className="tempContainer">

        <ResponsiveContainer>
            <LineChart  data={this.state.inputGraph}>
              <XAxis
              dataKey = 'time'
              domain={['dataMin', 'dataMax']}
              name = 'Time'
              tickFormatter = {(unixTime) => moment(unixTime).format('LLL ')}
              type = 'number'
              />
              <YAxis dataKey = 'state' tick={true}   domain = {['auto', 'auto']} name = 'Value' allowDecimals={false} scale={"linear"} label={{ value:"°C",  position: 'insideTopLeft' }}   />
              <CartesianGrid />
              <Tooltip  active={true}  coordinate={{ x: 100, y: 140 }} formatter={(value, name, props) => graphTooltip(value,name,props)}  labelFormatter={(value, name, props) => timeTooltip(value,name,props)}/>
              <Line type="stepAfter" dataKey="state" stroke="#329fff"  strokeWidth="2px" dot={false} activeDot={{r: 8}}/>
            </LineChart >
        </ResponsiveContainer></div>):("")}


{this.state.graphmode=="binary"? (
  <div className="graphContainer">
      <ResponsiveContainer>

          <LineChart  data={this.state.inputGraph}>
            <XAxis
            dataKey = 'time'
            domain = {['dataMin', 'dataMax']}
            name = 'Time'
            tickFormatter = {(unixTime) => moment(unixTime).format('HH:mm ')}
            type = 'number'
            />
            <YAxis dataKey = 'state' tick={false} name = 'Value' allowDecimals={false} ticks={[0,1]} scale={"linear"} width={90} label={<Ytitle upper={this.state.input_active} lower={this.state.input_inactive}/>}   />
            {/*}<YAxis dataKey = 'state' tick={false} name = 'Value' allowDecimals={false} ticks={[0,1]} scale={"linear"} label={{ value: this.state.inputGraphYaxis,  position: 'insideTopLeft' }}   />*/}
            <Tooltip  active={true}  coordinate={{ x: 100, y: 140 }} formatter={(value, name, props) => dataTooltip(value,name,props)}  labelFormatter={(value, name, props) => timeTooltip(value,name,props)}/>

            <Line
    dataKey="state"
            strokeWidth="2px"
            type="stepAfter"
            name = 'State:'
            shape="circle"
    stroke="#329fff"  strokeWidth="2px" dot={false} activeDot={{r: 8}}

            />
  </LineChart >

</ResponsiveContainer></div>):("")}



<p>Changes: {this.state.inputGraph.length-2}</p>

{/*If temperature show the min and max <b>{this.state.active_count}</b> <b>{this.state.inactive_count}</b>*/}
{this.state.graphmode=="binary"? (<span>
<p>Time spent in state {this.state.input_active}: {this.timeHMS(this.state.active_duration)} </p>
<p>Time spent in state {this.state.input_inactive}: {this.timeHMS(this.state.inactive_duration)}</p>
</span>):("")}

{this.state.graphmode=="temperature"? (<span>
<p>Maximum value: {this.state.maxval}°C</p>
<p>Minimum value: {this.state.minval}°C</p>
</span>):("")}


<div>
<Button className="pull-left" onClick={()=>this.backward()}><i className="fa fa-chevron-left"> </i> -1 Day</Button>
    <Button  onClick={()=>this.reset()}>Today</Button>
<Button className="pull-right" disabled={this.futureCheck(this.state.day)} onClick={()=>this.forward()}>+1 Day <i className="fa fa-chevron-right"></i></Button>
</div>




<p>Select specific date</p>
<FormControl type="date" value={this.state.graphdate} onChange={this.dateChange} ></FormControl >


</center>):(<span></span>)}

</Well>
              <hr/>
                  {this.state.data.CAM==true? (
                            <Well>
                              <h3>Camera</h3>      <Button onClick={this.buttonPress} data-cmd="customCAM" disabled={this.state.cam_dis}  >Request Shot</Button>&nbsp;<i>Images are automaticly deleted after 24h</i>
                              <br/>
                              <br/>
                              {this.state.img_title.length==0 ? (""):(
                              <div>
                            <center> <h4>{this.state.img_title}</h4></center>
                              <Thumbnail href="#" responsive src={"https://kab6ul.s3-eu-west-1.amazonaws.com/"+this.state.img_url} >
                               </Thumbnail>
                               </div>)}
                              <Grid>
                                <Row>
                                {this.state.files.map(
                                  (d, i) =>

                                        <Col xs={6} md={3} key={i}>
                                        <Thumbnail href="#"  alt="171x180" src={"https://kab6ul.s3-eu-west-1.amazonaws.com/"+d.full} >
                                         <p>{d.name}</p>
                                         <Button  onClick={()=>this.loadimage(d)} ><i className={"fa fa-eye"}></i></Button>
                                         <Button onClick={()=>this.delimage(d,i)}><i className={"fa fa-trash"}></i></Button>
                                         </Thumbnail>
                                        </Col>
                                )}
                                </Row>
                              </Grid>
                            </Well>):("")}

              <h4>Input Activity</h4>

              <HeatMap xLabels={xLabels} yLabels={yLabels} data={this.state.heatmap} onClick={this.gridClick} />
              <hr/>
              <h4>Event Activity</h4>
              {this.state.eventmap_loading ?( <span className="LoaderButton"><Glyphicon  glyph="refresh" className="spinning" /></span>)
                :(
              <HeatMap xLabels={xLabels} yLabels={yLabels} data={this.state.eventmap} onClick={this.gridClick} />)}
              <br/>
              <h3>Logs & Reports <small><i>{this.state.historyText}</i>&nbsp;</small>
              <h5 class="pull-right"><Button onClick={e => this.setState({ history_datetime_show:true })}> Select time range</Button>&nbsp;<b>Show:</b><Button onClick={()=>this.history_filter("none")} >All</Button><Button onClick={()=>this.history_filter(0xA0001)}>Events only</Button><Button onClick={()=>this.history_filter(0xA0002)}>Inputs only</Button></h5>
               </h3>
               <br/>
               <br/>

                {this.state.history_datetime_show ? (<Well>
                  <i>Select a start date and end date</i>
                  <table>
                  <tr>
                  <td>Start</td>
                  <td>End</td>
                  <td></td>
                  </tr>
                  <tr>
                  <td><FormControl type="date" onChange={e => this.setState({ history_time_start:e.target.value })}  placeholder="Start time" /></td>
                  <td><FormControl type="date" onChange={e => this.setState({ history_time_end:e.target.value })}   placeholder="End time" /></td>
                  <Button onClick={()=>this.history_load()}>Load Logs</Button>
                  </tr>
                  </table>

                  <span >{this.state.history_info}</span><br/>
                  <i>Reports take a few minutes to compile we will email you when its ready</i><br/>
                  <Button onClick={()=>this.request_report()}>Generate report</Button>


                  <hr></hr>







                  </Well>):("")}



               <br/>
              {this.state.rawLoading ? (<span></span>):(<div>
<span className="pull-right pad"><CSVLink   filename={"export_"+moment(this.state.history_time).format('YYYY-MM-DD hh:mm')+".csv"} data={this.state.history_csv} target="_blank" >Export as CSV</CSVLink ></span>
                <Well className="fontSmall">

                {this.state.raw.map(
                  (d, i) =>
                        <span key={i}>
                        {this.logitem(d,i)}
                        </span>
                )}


                </Well></div>)}



                {this.state.data.permission==255? (<div>
              <p>Controls</p>
                  {"reg_state" in this.state.data? (<Button onClick={this.buttonPress} data-cmd="DECT" data-id="" data-type="REG" >Open Registration ({this.state.data.reg_state.toString()})</Button>):(<span>No Dect fitted &nbsp;</span>)}
                  <Button onClick={this.buttonPress} data-cmd="customBeep"  >Beep</Button>

                  {/* Allow remote config on version 2.2.3.17 and above*/}

                  {this.checkVersion("2.2.3.17")==true ? (<a className="pull-right" href={"/program/"+this.props.match.params.id}>Configure Remotely</a>):("")}


                <p title={new Date(this.state.data.update_time)}><b>VERSION: </b>{this.defined(this.state.data.VERSION)} <b>Local IP</b>{this.defined(this.state.data.IP)}</p>

              <p>Software Update</p>
              <Button onClick={this.buttonPress} data-cmd="REBOOT" >Reboot</Button>


              <LoaderButton
                onClick={this.buttonPress}
                type="submit"
                data-cmd="PIC"
                data-type="bootloader"
                isLoading={this.state.isPicBootload}
                text={this.state.picButtonText}
                loadingText="Updating..."
                  />


              <LoaderButton
                onClick={this.buttonPress}
                type="submit"
                data-cmd="update"
                isLoading={this.state.isUpdating}
                text="Update 6UL"
                loadingText="Updating..."
                  />
                  </div>):(<span></span>)
                }
            </Jumbotron>
          </div>
        );
    }
}

/*

<Button onClick={this.buttonPress} data-cmd="update" >Update 6UL</Button>
<Button onClick={this.buttonPress} data-cmd="PIC" data-type="bootloader" >Update PIC</Button>
{this.state.inputData.map(
  (d, i) =>
        <span key={i}>
        {this.inputItem(d,i)}
        </span>
)}
*/



// WEBPACK FOOTER //
// ./src/containers/Altiom.js